import "./featured-case-studies.scss";


//Function for Indicator Dots
function changeIndicator(currentActive, newActive) {
  currentActive.classList.remove('case-study-active-indicator');
  newActive.classList.add('case-study-active-indicator');
}

//Function for slide class switching 
function switchSlides(current, next) {
  current.classList.remove('active-case-study');
  next.classList.add('active-case-study');
  next.classList.remove('post-active');
  next.classList.remove('pre-active');
}

//Function for next / prev arrows
function arrow(arrowId, direction, thisArrow) {
  var caseStudies = document.getElementsByClassName('js-case-study-' + arrowId);
  var caseStudyWrapper = document.getElementById('js-case-study-wrapper-' + arrowId);
  var activeCaseStudy = caseStudyWrapper.getElementsByClassName('active-case-study')[0];
  var currentlyActive = document.getElementsByClassName('js-case-study-indicator-' + arrowId + ' case-study-active-indicator')[0];
  var currentIndex = activeCaseStudy.dataset.index;
  var theseIndicatorDots = document.getElementsByClassName('js-case-study-indicator-' + arrowId);

  if (direction == "next") {
    var thisPrevArrow = document.getElementById('js-prev-arrow-' + arrowId);
    var nextIndex = ++currentIndex;
    var nextCaseStudy = caseStudies[nextIndex];
    var activeAddClass = 'post-active';
    var nextRemoveClass = 'pre-active';
    var nextAddClass = 'post-active';

    if (nextIndex == (caseStudies.length - 1)) {
      thisArrow.disabled = true;
    }

    if (nextIndex == 1 || nextIndex == 2) {
      thisPrevArrow.disabled = false;
    }

  } else if (direction == "prev") {
    var thisNextArrow = document.getElementById('js-next-arrow-' + arrowId);
    var nextIndex = --currentIndex;
    var nextCaseStudy = caseStudies[nextIndex];
    var activeAddClass = 'pre-active';
    var nextRemoveClass = 'post-active';
    var nextAddClass = 'pre-active';

    if (nextIndex == 0) {
      thisArrow.disabled = true;
    }

    if (nextIndex < caseStudies.length) {
      thisNextArrow.disabled = false;
    }
  } else {
    return;
  }

  activeCaseStudy.classList.add(activeAddClass);
  activeCaseStudy.classList.remove('active-case-study');

  nextCaseStudy.classList.add('active-case-study');
  nextCaseStudy.classList.remove(nextRemoveClass);
  nextCaseStudy.classList.remove(nextAddClass);

  changeIndicator(currentlyActive, theseIndicatorDots[nextIndex]);
}


// Generic vars
var blocks = document.getElementsByClassName('js-featured-case-studies');
var width = window.innerWidth;

if (blocks) {
  //For each block
  for (const block of blocks) {

    var blockId = block.dataset.block;
    var wrapper = document.getElementById('js-case-study-wrapper-' + blockId);
    var nextArrow = document.getElementById('js-next-arrow-' + blockId);
    var prevArrow = document.getElementById('js-prev-arrow-' + blockId);
    var indicatorDots = document.getElementsByClassName('js-case-study-indicator-' + blockId)

    if (wrapper) {
      var totalCaseStudies = wrapper.dataset.caseStudyCount;
    }

    // Mobile Functionality
    if (wrapper && width < 768 && totalCaseStudies > 1) {
      //Fires everytime the case studies block is scrolled
      wrapper.addEventListener('scroll', function () {
        var id = this.dataset.block;
        var caseStudyWrapper = document.getElementById('js-case-study-wrapper-' + id);
        var caseStudies = caseStudyWrapper.getElementsByClassName('js-case-study-' + id);
        var activeIndicator = document.getElementsByClassName('js-case-study-indicator-' + id + ' case-study-active-indicator')[0];
        var caseStudyWidth = caseStudies[0].offsetWidth;
        var maxPossibleWidth = caseStudyWidth * totalCaseStudies;
        var wrapperScrollPos = (caseStudyWrapper.scrollLeft + caseStudyWidth);
        var theseIndicatorDots = document.getElementsByClassName('js-case-study-indicator-' + id);

        if (wrapperScrollPos == caseStudyWidth) {
          changeIndicator(activeIndicator, theseIndicatorDots[0]);
        }

        if (wrapperScrollPos >= maxPossibleWidth) {
          changeIndicator(activeIndicator, theseIndicatorDots[(theseIndicatorDots.length - 1)]);
          return
        } else if (wrapperScrollPos == (caseStudyWidth * 2)) {
          changeIndicator(activeIndicator, theseIndicatorDots[1]);
        }

      });
    }

    //Desktop Functionality 
    if (wrapper && width >= 768 && totalCaseStudies > 1) {

      nextArrow.addEventListener('click', function () {
        var id = this.dataset.block;
        arrow(id, "next", this);
      });

      prevArrow.addEventListener('click', function () {
        var id = this.dataset.block;
        arrow(id, "prev", this);
      });

      //Indicator dots function
      for (var i = 0; i < indicatorDots.length; i++) {

        indicatorDots[i].addEventListener('click', function () {
          var thisIndicator = this;
          var id = this.dataset.block;
          var caseStudies = document.getElementsByClassName('js-case-study-' + id);
          var thisCaseStudyId = thisIndicator.dataset.caseStudy;
          var nextCaseStudy = document.getElementById(thisCaseStudyId);
          var nextIndex = nextCaseStudy.dataset.index;
          var caseStudyWrapper = document.getElementById('js-case-study-wrapper-' + id);
          var activeCaseStudy = caseStudyWrapper.getElementsByClassName('active-case-study')[0];
          var currentIndex = activeCaseStudy.dataset.index;
          var currentlyActive = document.getElementsByClassName('js-case-study-indicator-' + id + ' case-study-active-indicator')[0];
          var thisNextArrow = document.getElementById('js-next-arrow-' + id);
          var thisPrevArrow = document.getElementById('js-prev-arrow-' + id);

          if (nextCaseStudy != activeCaseStudy && nextIndex > currentIndex) {
            activeCaseStudy.classList.add('post-active');

            switchSlides(activeCaseStudy, nextCaseStudy);

            changeIndicator(currentlyActive, thisIndicator);

            if (nextIndex == (caseStudies.length - 1)) {
              thisNextArrow.disabled = true;
            }

            if (nextIndex == 1 || nextIndex == 2) {
              thisPrevArrow.disabled = false;
            }

          } else if (nextCaseStudy != activeCaseStudy && nextIndex < currentIndex) {
            activeCaseStudy.classList.add('pre-active');

            switchSlides(activeCaseStudy, nextCaseStudy);

            changeIndicator(currentlyActive, thisIndicator);

            if (nextIndex == 0) {
              thisPrevArrow.disabled = true;
            }

            if (nextIndex < caseStudies.length) {
              thisNextArrow.disabled = false;
            }
          }
        });
      }
    }
  }
}



